import { render, staticRenderFns } from "./Shitang12.vue?vue&type=template&id=197bd914&scoped=true"
import script from "./Shitang12.vue?vue&type=script&lang=js"
export * from "./Shitang12.vue?vue&type=script&lang=js"
import style0 from "./Shitang12.vue?vue&type=style&index=0&id=197bd914&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197bd914",
  null
  
)

export default component.exports